import { classNames } from "primereact/utils";
import React from "react";

type Props = {
  id: string;
  invalid?: boolean;
  warning?: boolean;
  children: React.ReactNode;
  className?: string;
};
export const HelpText = ({ id, invalid, warning, children, className }: Props) => {
  return (
    <small
      className={classNames("text-sm font-medium", className, {
        "text-warning": warning,
        "text-urbe-errorValidation": invalid,
        "text-urbe-textSecondary": !invalid,
      })}
      id={id}
      role="alert"
    >
      {children}
    </small>
  );
};
